var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _path21, _circle, _path22, _line, _line2, _path23, _path24, _path25, _path26, _g4, _g5, _path27, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 413,
    height: 349,
    viewBox: "0 0 413 349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11315",
    "data-name": "Rectangle 11315",
    width: 413,
    height: 349,
    transform: "translate(636.954 389.619)",
    fill: "#2680eb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_53",
    "data-name": "Mask Group 53",
    transform: "translate(-636.954 -389.619)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27948",
    "data-name": "Group 27948",
    transform: "translate(639.57 415.694)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27801",
    "data-name": "Group 27801",
    transform: "translate(0 60.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27800",
    "data-name": "Group 27800",
    transform: "translate(0 26.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11312",
    "data-name": "Rectangle 11312",
    width: 17.396,
    height: 17.396,
    transform: "translate(0 2.572)",
    fill: "none",
    stroke: "#9ed523",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55631",
    "data-name": "Path 55631",
    d: "M366.063,162.02l5.732,5.841,15.142-14.535",
    transform: "translate(-361.56 -153.327)",
    fill: "none",
    stroke: "#9ed523",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11313",
    "data-name": "Rectangle 11313",
    width: 17.396,
    height: 17.396,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#2680eb",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11314",
    "data-name": "Rectangle 11314",
    width: 17.396,
    height: 17.396,
    transform: "translate(0 55.423)",
    fill: "none",
    stroke: "#2680eb",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27797",
    "data-name": "Group 27797",
    transform: "translate(15.325 0)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27792",
    "data-name": "Group 27792",
    transform: "translate(10.599 97.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55587",
    "data-name": "Path 55587",
    d: "M453.622,222.554c5.02,8.445,6.684,18.724-.886,23.224s-28.817-1.1-33.837-9.545,4.357-16.324,11.927-20.824S448.6,214.108,453.622,222.554Z",
    transform: "translate(-412.29 -191.971)",
    fill: "#ffb6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55588",
    "data-name": "Path 55588",
    d: "M445.681,217.341l-7.389,7.9-18.238-18.587c-2.182-2.04-9.043-10.241-7-12.423h0c2.04-2.182,7.249,1.367,11.864,5.324l11.572,11.281Z",
    transform: "translate(-412.677 -193.566)",
    fill: "#ffb6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55589",
    "data-name": "Path 55589",
    d: "M426.5,211.357a5.574,5.574,0,0,0-7.511.005,5.392,5.392,0,0,0-1.553,4.919,1.956,1.956,0,0,1-.885,2.009,5.379,5.379,0,0,0-1.674,7.31,2.034,2.034,0,0,1-.16,2.307,5.3,5.3,0,0,0-.826,1.554,5.409,5.409,0,0,0,3.42,6.842l20.54,5.776,1.634-4.9,5.375,4.726L452,233.784Z",
    transform: "translate(-412.602 -192.25)",
    fill: "#ffb6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55590",
    "data-name": "Path 55590",
    d: "M452.951,217.751s12.717,21.473-1.594,27.674l-16.749-20.331Z",
    transform: "translate(-410.911 -191.618)",
    fill: "#ffb6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55591",
    "data-name": "Path 55591",
    d: "M420.228,235.5s10.616,1.561,12.913.228c1.9-1.1,7.926-6.786-15.657-9.585",
    transform: "translate(-412.29 -190.943)",
    fill: "none",
    stroke: "#c77c6b",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55592",
    "data-name": "Path 55592",
    d: "M420.024,217.751s17.646,2.215,18.2,7.609-7.579,4.241-7.579,4.241",
    transform: "translate(-412.086 -191.618)",
    fill: "none",
    stroke: "#c77c6b",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55593",
    "data-name": "Path 55593",
    d: "M453.77,218.185h0l-19.727,7.935c-2.683,1.314-8.057-.4-9.372-3.085h0c-.859-1.835.726-2.622,3.408-3.936l11.42-5.475A10.385,10.385,0,0,1,453.77,218.185Z",
    transform: "translate(-411.73 -192.052)",
    fill: "#ffb6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55594",
    "data-name": "Path 55594",
    d: "M440.431,213.116s-15.228,6.2-15.889,8.542,4.265,7.388,11.82,3.435,8.987-4.286,8.987-4.286a17.218,17.218,0,0,0,0,15.2",
    transform: "translate(-411.727 -191.992)",
    fill: "none",
    stroke: "#c77c6b",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55595",
    "data-name": "Path 55595",
    d: "M425.538,211.249s6.955,1.208,7.192,5.371",
    transform: "translate(-411.642 -192.142)",
    fill: "none",
    stroke: "#c77c6b",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27794",
    "data-name": "Group 27794",
    transform: "translate(0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_55596",
    "data-name": "Path 55596",
    d: "M623.878,111.837c12.43,8.918,17.936,14.54,19.951,24.96,1.649,8.525-2.866,13.061.249,22.915,1.962,6.205,4.658,7.4,9.509,15.677a80.678,80.678,0,0,1,8.526,20.725,21.221,21.221,0,0,1-14.032,3.368c-7.912-1.062-13.74.415-21.847,2.889s-36.073-3.577-40.719-3.264-21.98,1.587-32.141-8.661c.255.257,5.49-12.9,5.672-13.867,1.862-9.967-2.367-18.954-2.088-28.777.145-5.067,2.664-9.154,3.863-13.934,1.23-4.9,1.614-10.047,4.509-14.437,3.1-4.7,9.059-8.5,14.2-10.976C595.3,100.839,610.363,102.142,623.878,111.837Z",
    transform: "translate(-390.748 -103.535)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55597",
    "data-name": "Path 55597",
    d: "M601.206,107.894c-20.529-3.609-33.2,8.338-36.513,27.162,0,0-.869,12.208-1,13.2a41.747,41.747,0,0,0,9.982,40.448,6.655,6.655,0,0,0,3.934,1.635c30.708,5.084,37.5-22,37.5-22,.506-1.505,16.991-18.218,17.273-19.823C635.693,129.69,621.735,111.5,601.206,107.894Z",
    transform: "translate(-390.048 -103.236)",
    fill: "#ffb6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55598",
    "data-name": "Path 55598",
    d: "M613.873,196.794v-46H587.215v42.673a7.55,7.55,0,0,1-4.026,6.687c-9.353,4.929-26.543,13.34-37.659,14.891,0,0,56.49,16.508,99.781-1.252,0,0-16.808-4.144-27.779-10.522A7.474,7.474,0,0,1,613.873,196.794Z",
    transform: "translate(-391.38 -99.73)",
    fill: "#ffb6a6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55599",
    "data-name": "Path 55599",
    d: "M551.243,325.418s72.008,6.328,100.031-2.109c0,0,9.052,19.113,0,30.054,0,0-30.937,44.978-37.31,56.578,0,0-20.6,2.636-27.123,0,0,0-26.112-51.715-35.6-54.937C551.243,355,542.35,337.545,551.243,325.418Z",
    transform: "translate(-391.238 -85.838)",
    fill: "#342e4f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55600",
    "data-name": "Path 55600",
    d: "M502.07,300.832l-16.122-10.713,7.012-11.544q16.138-26.568,34.295-51.829L530.3,222.5l35.514,9L556.317,247c-10.827,17.67-46.227,52.38-46.227,52.38A5.885,5.885,0,0,1,502.07,300.832Z",
    transform: "translate(-396.178 -93.956)",
    fill: "#ffb6a6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55601",
    "data-name": "Path 55601",
    d: "M440.464,242.69l16.22-9.006,26.632,14.751c15.353,7.026,26.233,15.772,39.919,25.466l2.932-4.138-20.174,28.484-1.842.632c-10.478-5.339-20.023-12.369-29.345-19.54a68.217,68.217,0,0,1-9.259-8.6Z",
    transform: "translate(-399.841 -93.055)",
    fill: "#ffb6a6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55602",
    "data-name": "Path 55602",
    d: "M676.353,310.707l20.5-20.384-8.07-14.112c-8.212-14.519-11.02-26.275-20.959-39.666L659.1,224.793l-26.908,17.619,7.284,12.694a403.858,403.858,0,0,0,27.5,41.713Z",
    transform: "translate(-384.401 -93.771)",
    fill: "#ffb6a6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55603",
    "data-name": "Path 55603",
    d: "M714.519,371.161l16.522-10.422-17.263-39.193c-4.667-12.825-12.99-24.7-20.183-36.107h0l-20.924,19.375.423,1.009A155.679,155.679,0,0,0,689.2,335.048Z",
    transform: "translate(-381.142 -88.887)",
    fill: "#ffb6a6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55604",
    "data-name": "Path 55604",
    d: "M632.956,209.051s23.793-2.881,30.206,22.28C663.162,231.332,641.723,240.546,632.956,209.051Z",
    transform: "translate(-384.34 -95.047)",
    fill: "#ffb6a6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55605",
    "data-name": "Path 55605",
    d: "M549.041,345.166s-25.221,112.3,24.6,183.481h23.423s-9-90.553,0-121.8C597.068,406.849,584.968,346.534,549.041,345.166Z",
    transform: "translate(-391.611 -84.078)",
    fill: "#342e4f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55606",
    "data-name": "Path 55606",
    d: "M651.075,345.166s25.22,112.3-24.6,183.481H603.048s9-91.06,0-122.306C603.048,406.341,615.148,346.534,651.075,345.166Z",
    transform: "translate(-386.748 -84.078)",
    fill: "#342e4f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55607",
    "data-name": "Path 55607",
    d: "M581.9,112.941s-8.054,18.889,24.34,28.345c0,0,3.832,12.908,4.154,20.323,0,0,31.541,2.471,27.029-24.066s-35.9-32.537-50.282-30.176-22.213,11.181-22.264,25.641C564.878,133.009,572.16,115.583,581.9,112.941Z",
    transform: "translate(-389.822 -103.265)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55608",
    "data-name": "Path 55608",
    d: "M584.817,109.392c-.448.426-7.782,7.6-5.8,16.207,2.12,9.19,12.974,11.8,15.527,12.418a25.886,25.886,0,0,0,17.6-2.316",
    transform: "translate(-388.711 -103.064)",
    fill: "none",
    stroke: "#342e4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55609",
    "data-name": "Path 55609",
    d: "M608.3,106.284c3.5.8,20.989,5.1,27.513,18.715,3.382,7.058,4,17,4.06,18.053.388,6.918-.939,6.763-.226,11.008,1.484,8.83,7.48,11.037,13.081,21.576a51.977,51.977,0,0,1,4.962,13.871",
    transform: "translate(-386.325 -103.314)",
    fill: "none",
    stroke: "#342e4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55610",
    "data-name": "Path 55610",
    d: "M568.2,116.916a43.451,43.451,0,0,0-7.677,11.4,38.072,38.072,0,0,0-3.071,8.848c-1.508,7.452,2.764,12.872,3.02,19.613.171,4.477-4.286,22.017-8.073,24.219",
    transform: "translate(-390.827 -102.458)",
    fill: "none",
    stroke: "#342e4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55611",
    "data-name": "Path 55611",
    d: "M585.949,108.531a44,44,0,0,0-18.508,25.621",
    transform: "translate(-389.616 -103.133)",
    fill: "none",
    stroke: "#342e4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55612",
    "data-name": "Path 55612",
    d: "M501.917,260.076s5-.942,10,9.794",
    transform: "translate(-394.892 -90.931)",
    fill: "none",
    stroke: "#c77c6b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27793",
    "data-name": "Group 27793",
    transform: "translate(212.751 45.401)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_280",
    "data-name": "Ellipse 280",
    cx: 11.261,
    cy: 10.172,
    rx: 11.261,
    ry: 10.172,
    transform: "translate(0 22.002) rotate(-77.662)",
    fill: "#ffb6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55613",
    "data-name": "Path 55613",
    d: "M615.972,153.6s-6.018-2.936-8.659,5.431c0,0,4.843.294,6.017,2.789",
    transform: "translate(-599.156 -144.944)",
    fill: "none",
    stroke: "#342e4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 3.545,
    cy: 3.545,
    r: 3.545,
    transform: "translate(8.157 20.248)",
    fill: "#fff"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55614",
    "data-name": "Path 55614",
    d: "M572.109,142.28a21.287,21.287,0,0,1-3.377,9.552c-1.237,1.768-4.183,3.815,1.248,6.15",
    transform: "translate(-389.666 -100.415)",
    fill: "none",
    stroke: "#342e4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55615",
    "data-name": "Path 55615",
    d: "M585.579,147.839c-.282,1.291-1.122,2.2-1.874,2.04s-1.133-1.345-.85-2.635,1.12-2.2,1.872-2.04S585.861,146.548,585.579,147.839Z",
    transform: "translate(-388.382 -100.182)",
    fill: "#342e4f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55616",
    "data-name": "Path 55616",
    d: "M567.006,145.572c-.258,1.177-1.022,2.009-1.707,1.86s-1.033-1.225-.776-2.4,1.021-2.009,1.707-1.859S567.264,144.4,567.006,145.572Z",
    transform: "translate(-389.857 -100.345)",
    fill: "#342e4f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55617",
    "data-name": "Path 55617",
    d: "M570.456,164.395s6.9,2.839,14.751-3.916",
    transform: "translate(-389.373 -98.95)",
    fill: "none",
    stroke: "#342e4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_282",
    "data-name": "Ellipse 282",
    cx: 7.465,
    cy: 7.465,
    r: 7.465,
    transform: "translate(188.37 40.735)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55618",
    "data-name": "Path 55618",
    d: "M570.145,146.607c-.459,3.728-3.459,6.426-6.7,6.026s-5.492-3.745-5.033-7.473,3.459-6.427,6.7-6.027S570.6,142.879,570.145,146.607Z",
    transform: "translate(-390.347 -100.672)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    x2: 17.622,
    transform: "translate(203.3 49.716)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    "data-name": "Line 144",
    x2: 5.582,
    y2: 0.527,
    transform: "translate(168.067 44.488)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55619",
    "data-name": "Path 55619",
    d: "M569.266,146.081s6.092-1.688,8.573,1.424",
    transform: "translate(-389.469 -100.146)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55620",
    "data-name": "Path 55620",
    d: "M581.239,134.269c1.431-1.432,5.738,1.159,6.024,1.334,2.171,1.33,4.062,3.395,3.732,3.881-.192.284-1-.174-3.015-.722-4.294-1.169-6.16-.6-6.937-1.948A2.276,2.276,0,0,1,581.239,134.269Z",
    transform: "translate(-388.544 -101.095)",
    fill: "#342e4f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55621",
    "data-name": "Path 55621",
    d: "M568.473,134.446c-.927-1.384-4.819.019-5.077.116-1.966.727-3.823,2.093-3.635,2.538.11.259.835.019,2.55-.1,3.655-.258,5.07.5,5.914-.466A1.873,1.873,0,0,0,568.473,134.446Z",
    transform: "translate(-390.235 -101.095)",
    fill: "#342e4f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55622",
    "data-name": "Path 55622",
    d: "M584.108,185.761a29.084,29.084,0,0,0,19.674-13.815s-6.963,16.733-19.674,19.155Z",
    transform: "translate(-388.274 -98.027)",
    fill: "#342e4f",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56146",
    "data-name": "Path 56146",
    d: "M10.73,0C13.648,3.667,29.669,10.051,33,13.6S43.226,27.866,44.165,30.343s3.653,15.617,3.073,17.823-3.278.956-4.782-3.008-3.97-12.606-3.97-12.606-9.237-10.158-12.521-9.479c-2.015.415-.978,3.031,2.244,6.289s8.625,7.828,5.817,10.489c-1.762,1.672-6.461-.257-10.792-4.919C17.644,28.912,9.185,27.5,5.448,22.689S0,9.037,0,9.037",
    transform: "translate(334.586 259.356) rotate(20)",
    fill: "#ffb6a6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27951",
    "data-name": "Group 27951",
    transform: "translate(0 214.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55625",
    "data-name": "Path 55625",
    d: "M471,459.008c-1.773,3.366,18.279-58.637,8.939-86.3C478.69,374.322,460.117,426.742,471,459.008Z",
    transform: "translate(-381.391 -328.82)",
    fill: "#2862b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55626",
    "data-name": "Path 55626",
    d: "M464.846,435.612c-.3,2.525-18.314-90.251-55.338-86.5C408.887,352.368,426.368,396.816,464.846,435.612Z",
    transform: "translate(-386.069 -330.729)",
    fill: "#1263be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55627",
    "data-name": "Path 55627",
    d: "M465.851,448.95c.026-.026.411-19.848-.378-47.311-1.179-26.591-3.532-60.821-18.017-69.548C445.784,335.766,438.96,406.484,465.851,448.95Z",
    transform: "translate(-383.173 -332.091)",
    fill: "#5da5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55628",
    "data-name": "Path 55628",
    d: "M467.978,455.052c1.253-1.15-42.333-78.1-80.156-55.641C387.22,401.581,421.022,415.45,467.978,455.052Z",
    transform: "translate(-387.815 -327)",
    fill: "#65adff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27795",
    "data-name": "Group 27795",
    transform: "translate(111.811 105.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55623",
    "data-name": "Path 55623",
    d: "M575.493,201.5s17.3,15.1,53.665,1.821c0,0,20.846,5.438,29.543,7.529s44.253,60.216,44.253,60.216-17.614,17.2-42.272,23.351l-8.365-23.351,11.007,95.552s-78.378,14.274-120.651-2.11l6.154-97.477-9.212,11.521s-10.533-16.031-33.269-26.2c0,0,21.832-27.875,27.116-35.963s18.893-9.709,27.7-11.181A74.876,74.876,0,0,0,575.493,201.5Z",
    transform: "translate(-506.346 -201.497)",
    fill: "#538397"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55624",
    "data-name": "Path 55624",
    d: "M683.15,291.008s-4.4,9.1,0,24.072",
    transform: "translate(-380.456 -88.439)",
    fill: "none",
    stroke: "#c77c6b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29806",
    "data-name": "Group 29806",
    transform: "translate(973.683 416.892) rotate(17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28011",
    "data-name": "Group 28011",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56457",
    "data-name": "Path 56457",
    d: "M14.842.013a5.453,5.453,0,0,0-3.356.922A14.257,14.257,0,0,0,8.439,3.277,19.808,19.808,0,0,0,6.252,6.331a16.269,16.269,0,0,0-.864,1.753c-.275.567-.685,1.15-.979,1.64A4.157,4.157,0,0,1,1.49,12.016c1.174.375,2.273-.355,3.14-1.1a12.07,12.07,0,0,0,2.153-2.7c.65-1.024,1.249-2.09,1.952-3.08a9.357,9.357,0,0,1,2.6-2.4,5.832,5.832,0,0,1,3.186-1.279,8.408,8.408,0,0,1,3.444,1.083,11.564,11.564,0,0,1,2.752,2.052,13.39,13.39,0,0,1,2.128,2.8,25.681,25.681,0,0,1,3.5,14.395c-.06,1.284-.187,2.566-.3,3.845a14.772,14.772,0,0,1-.708,3.527c-.8,2.317-2.395,4.324-3.624,6.422a14.332,14.332,0,0,1-2.027,2.983,8.054,8.054,0,0,1-1.347,1.043c-.526.346-1.007.754-1.517,1.122-.473.342-.978.646-1.426,1.02-.482.4-.907.872-1.348,1.316a24.3,24.3,0,0,0-2.343,2.9c-1.336,1.842-2.264,4.3-4.406,5.385a6.208,6.208,0,0,1-3.45.41A2.8,2.8,0,0,1,1.563,49.7a10.894,10.894,0,0,1-.294-3.268C.632,47.344-.176,48.39.034,49.573a4.575,4.575,0,0,0,1.612,2.8,5.164,5.164,0,0,0,3.349.9,6.184,6.184,0,0,0,3.589-.986c2.054-1.417,3.018-3.712,4.444-5.668a23.569,23.569,0,0,1,2.226-2.688,16.154,16.154,0,0,1,1.229-1.188c.512-.375,1.045-.716,1.551-1.1a21.971,21.971,0,0,0,2.8-2.152,15.749,15.749,0,0,0,2.022-2.96,52.277,52.277,0,0,0,3.712-6.495c.954-2.33,1.035-4.977,1.2-7.459a28.274,28.274,0,0,0-.545-7.783,25.691,25.691,0,0,0-3.975-9.522A14.612,14.612,0,0,0,19.579,1.8,10.118,10.118,0,0,0,17.411.705,9.406,9.406,0,0,0,14.842.013Zm-13.53,48.3.008.062Z",
    transform: "translate(0)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56458",
    "data-name": "Path 56458",
    d: "M8.3.018A4.865,4.865,0,0,1,11.064,1.5a16.422,16.422,0,0,1,1.822,3,13.056,13.056,0,0,1,1.558,3.318,34.887,34.887,0,0,1,.752,3.756,32.533,32.533,0,0,1,.185,3.956,21.136,21.136,0,0,1-.252,3.719,20.681,20.681,0,0,1-3.034,6.864c-.4.673-.778,1.347-1.232,1.984A9.713,9.713,0,0,1,9.328,29.92a3.9,3.9,0,0,1-2.051.689,8.05,8.05,0,0,1-2.253.1c-.3-.046-.583-.154-.879-.216-.24-.05-.694-.021-.89-.174a.205.205,0,0,1-.02-.3c.1-.1.277-.04.4-.024a12.322,12.322,0,0,0,1.238.071,7.443,7.443,0,0,0,2.465-.473,3.918,3.918,0,0,0,.875-.418,5.8,5.8,0,0,0,.779-.905l-.108.142a36.918,36.918,0,0,0,3.754-6.232,12.113,12.113,0,0,0,1.087-3.367,22.363,22.363,0,0,0,.19-3.742A25.143,25.143,0,0,0,12.9,7.719a18.457,18.457,0,0,0-1.7-3.235A5.783,5.783,0,0,0,9.151,1.86a2.184,2.184,0,0,0-1.307-.388c-.54.1-1.081.182-1.619.3A2.6,2.6,0,0,0,4.756,2.4,11.714,11.714,0,0,0,3.833,3.68,14.277,14.277,0,0,0,2.41,6.446a13.2,13.2,0,0,0-.493,1.746c-.071.3-.145.607-.2.914-.029.156-.052.313-.073.471,0-.033-.06.484-.034.261a22.745,22.745,0,0,0-.13,3.824c.055,1.215.285,2.42.306,3.635.01.574-.086,1.144-.071,1.717a4.989,4.989,0,0,0,.086.825c.04.2.238.6.037.767-.41.334-.559-.751-.614-.957-.14-.523-.268-1.029-.359-1.564-.2-1.176-.5-2.328-.664-3.51a16.028,16.028,0,0,1-.146-3.745A25.111,25.111,0,0,1,.665,7.175a14.859,14.859,0,0,1,1.355-3.3,15.3,15.3,0,0,1,.992-1.588A4.15,4.15,0,0,1,4.4.845,7.135,7.135,0,0,1,6.286.266,6.7,6.7,0,0,1,8.3.018Z",
    transform: "translate(7.839 7.156)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56459",
    "data-name": "Path 56459",
    d: "M.267.04A4.586,4.586,0,0,1,1.716,2.988a26.311,26.311,0,0,0,.758,3.635c.725,2.334,1.81,4.534,2.262,6.951a16,16,0,0,1,.227,1.685c.026.324.136,1.42-.224,1.573-.543.231-.318-.952-.33-1.188a8,8,0,0,0-.314-1.805,30.553,30.553,0,0,0-1.37-3.321A26.293,26.293,0,0,1,1.53,7.089a18.136,18.136,0,0,1-.521-3.9A6.706,6.706,0,0,0,.682,1.2,2.085,2.085,0,0,0,.229.419C.165.357.027.288,0,.193A.159.159,0,0,1,.267.04Z",
    transform: "translate(17.409 8.344)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56460",
    "data-name": "Path 56460",
    d: "M.642.1A.558.558,0,0,1,.757.446a4.346,4.346,0,0,0,.18.681A2.427,2.427,0,0,0,1.68,2.178a22.3,22.3,0,0,0,2.6,1.175A5.025,5.025,0,0,1,6.269,5.107a7.041,7.041,0,0,1,.579,1.239,11.877,11.877,0,0,1,.324,1.587c.026.127.034.5-.042.161-.045-.2-.073-.408-.122-.609a4.77,4.77,0,0,0-.555-1.323A3.805,3.805,0,0,0,4.2,4.372a25.068,25.068,0,0,1-2.639-.638A2.6,2.6,0,0,1,.072,1.463,2.951,2.951,0,0,1,.039.387C.1.118.383-.154.642.1Z",
    transform: "translate(8.497 15.148)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56461",
    "data-name": "Path 56461",
    d: "M15.616.01c-.141-.089-.048.422-.04.523.024.274.06.548.082.823.053.634.041,1.274.058,1.909.03,1.186.116,2.395.068,3.579A10.554,10.554,0,0,1,14.568,10.4a11.011,11.011,0,0,1-1.714,3.039c-.753.853-2.11.96-3.162,1.187s-2.377.224-3.27.9c-.439.335-.84.714-1.281,1.046-.4.3-1.088.589-1.3,1.067s-.2,1.055-.39,1.554a3,3,0,0,1-.908,1.3,1.236,1.236,0,0,1-1.227.121C.8,20.317.88,19.542.93,19.036a2.466,2.466,0,0,1,.621-1.426c.417-.44.936-.765,1.359-1.2.345-.357.835-.757.911-1.278A6.34,6.34,0,0,0,3.536,13.4a16.582,16.582,0,0,1-.065-3.878c.03-.241.276-1.124.71-.855.375.35.356,1.1.389,1.568s-.039,1.227.525,1.408c.29.093.34-.118.068-.216-.276-.131-.254-.475-.251-.734.01-.683.1-2.992-1.167-2.521-1.022.38-.962,1.982-.969,2.875a15.909,15.909,0,0,0,.064,1.807c.063.589.195,1.169.251,1.758.048.5-.524.815-.856,1.128-.423.4-.915.721-1.311,1.148a3.757,3.757,0,0,0-.868,3.179,1.759,1.759,0,0,0,2.356,1.411,3.474,3.474,0,0,0,2.029-2.58c.078-.278.1-.569.181-.846a3.829,3.829,0,0,1,.571-.372,12.944,12.944,0,0,0,1.365-1.115,2.612,2.612,0,0,1,1.32-.7c.584-.126,1.14-.2,1.672-.3.56-.1,1.11-.242,1.664-.371a5.384,5.384,0,0,0,1.674-.588A6.683,6.683,0,0,0,15.011,11.7c.256-.533.486-1.081.72-1.624a12.85,12.85,0,0,0,.77-1.886,8.49,8.49,0,0,0-.22-3.772c-.233-1.224-.438-2.49-.591-3.712l0-.012A6.256,6.256,0,0,1,15.616.01ZM3.468,9.539Zm-.449,4.529ZM15.689.705c0-.016,0,0,0,0Z",
    transform: "translate(1.979 18.594)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56462",
    "data-name": "Path 56462",
    d: "M.067,0A3.381,3.381,0,0,1,.146.787C.14.971.1,1.152.089,1.335c0,.05-.066.593-.029.322A9.566,9.566,0,0,0,.278,4.888C.382,5.4.524,5.9.661,6.4c.063.232.134.46.174.7a2.157,2.157,0,0,1,.084.658c.066-.665.1-1.332.149-2a12.023,12.023,0,0,0,.069-1.894,11.146,11.146,0,0,0-.309-2A5.421,5.421,0,0,0,.067,0Zm.949,2.851c.008.056.015.112.022.168ZM.857,7.242Z",
    transform: "translate(17.195 17.666)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56463",
    "data-name": "Path 56463",
    d: "M.423.155A1.506,1.506,0,0,0,0,0C.084,0,.243.129.309.175A4.65,4.65,0,0,1,1.477,2c.122.321.264.631.4.948.07.168.139.337.208.5q.043.105.093.208c.01.022.151.343.053.111.111.266.24.524.343.793.054.142.121.628.246.712-.016-.005.107-1.03.107-1.115A5.109,5.109,0,0,0,2.711,2.6,4.553,4.553,0,0,0,.423.155ZM1.966,3.166ZM2,3.256l.02.047Zm.811,2.013Zm0,0Z",
    transform: "translate(12.878 19.018)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56464",
    "data-name": "Path 56464",
    d: "M.416.085A.743.743,0,0,0,0,0C.566.138.4.679.381,1.135A5.425,5.425,0,0,0,.424,2.68a1.418,1.418,0,0,0,.8,1.058A.736.736,0,0,0,2.26,3.213c-.014.042-.218.086-.264.094a.481.481,0,0,1-.388-.225,2.628,2.628,0,0,1-.336-1.117c.005.041.007.052,0,.032l.007.053a3.907,3.907,0,0,0-.3-1A2.04,2.04,0,0,0,.416.085ZM.263.1Z",
    transform: "translate(5.928 26.886)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56465",
    "data-name": "Path 56465",
    d: "M1.313,0A1.376,1.376,0,0,0,0,.872C.023.8.37.695.439.676A1.129,1.129,0,0,1,1.13.722a4.18,4.18,0,0,0,1.292.525A3.348,3.348,0,0,0,4.951.3S5.1.19,5.093.192a5.523,5.523,0,0,1-.637.181A4.428,4.428,0,0,1,3.769.338C3.246.3,2.738.251,2.219.181c.247.033-.248-.056-.3-.068A3.279,3.279,0,0,0,1.313,0ZM2.79.268l.056.008Z",
    transform: "translate(9.819 36.929)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56466",
    "data-name": "Path 56466",
    d: "M.24,0C.213.468.2.945.153,1.415a5,5,0,0,0-.1,1.706A5.073,5.073,0,0,0,.672,4.547a5.944,5.944,0,0,0,.429.56c.043.052.231.2.231.264A1.891,1.891,0,0,0,1.268,5a15.84,15.84,0,0,0-.222-2.233C.915,2.29.7,1.846.555,1.373.417.917.335.465.24,0ZM1.311,5.341Z",
    transform: "translate(8.814 23.843)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56467",
    "data-name": "Path 56467",
    d: "M2.127,0A2.327,2.327,0,0,1,3.194.28a1.7,1.7,0,0,1,.427.284c.1.1.1.316.176.39C3.373.291,2.321.918,1.824,1.163A13.108,13.108,0,0,0,0,2.31c.084-.084.087-.6.13-.732a2.625,2.625,0,0,1,.433-.8A1.876,1.876,0,0,1,2.127,0Z",
    transform: "translate(10.291 10.938)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56468",
    "data-name": "Path 56468",
    d: "M3.561.057A2.957,2.957,0,0,0,.8.867a2.91,2.91,0,0,0-.7,1.38A5.449,5.449,0,0,0,0,3.077a2.992,2.992,0,0,1,0,.738A18.6,18.6,0,0,1,2.035,1.383C2.691.739,4.06.075,4.894.793A2.444,2.444,0,0,0,3.561.057ZM2.2,1.221Z",
    transform: "translate(9.592 12.045)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56469",
    "data-name": "Path 56469",
    d: "M3.11.075c.149.032.368.179.509.179A2.749,2.749,0,0,0,2.181.69q.183-.108-.06.035-.206.119-.413.235A8.218,8.218,0,0,0,.946,1.4a3.778,3.778,0,0,0-.9,1.047C.066,2.433,0,2.054,0,2.008a2.158,2.158,0,0,1,.1-.694A1.657,1.657,0,0,1,.735.465,3.171,3.171,0,0,1,3.11.075Z",
    transform: "translate(10.786 13.018)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56470",
    "data-name": "Path 56470",
    d: "M2.874.092C2.732.021,2.2.4,2.1.485a5.1,5.1,0,0,0-.414.359c-.063.06-.5.5-.3.293a6.028,6.028,0,0,0-.764.837c-.095.141-.493.754-.439.916A1.97,1.97,0,0,1,.591.641,2.47,2.47,0,0,1,2.874.092Z",
    transform: "translate(11.52 13.648)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56471",
    "data-name": "Path 56471",
    d: "M1.621,0a3.176,3.176,0,0,0-.8,1.092c-.131.264-.27.524-.4.789-.052.107-.356.576-.323.676A2.23,2.23,0,0,1,.273.827,1.7,1.7,0,0,1,.846.247,1.728,1.728,0,0,1,1.274.058,2.176,2.176,0,0,0,1.621,0Z",
    transform: "translate(12.988 14.435)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56472",
    "data-name": "Path 56472",
    d: "M1.253,0A2.044,2.044,0,0,0,.129,1.126a2.345,2.345,0,0,0,.3,2.023,3.093,3.093,0,0,1,.123-.71C.592,2.16.617,1.88.668,1.6A4.337,4.337,0,0,1,1.253,0ZM1.086.268Z",
    transform: "translate(14.084 15.432)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56473",
    "data-name": "Path 56473",
    d: "M.913,0A4.638,4.638,0,0,0,.546,1.381c-.031.227-.069.453-.1.679A2.634,2.634,0,0,0,.318,2.8,2.639,2.639,0,0,1,.062,1.08,1.788,1.788,0,0,1,.407.434C.5.327.879.1.913,0Z",
    transform: "translate(14.955 16.442)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56474",
    "data-name": "Path 56474",
    d: "M.706,0C.435.98.616,1.886.316,2.864c.034-.1-.192-.548-.222-.676a2.754,2.754,0,0,1-.076-.98A1.918,1.918,0,0,1,.282.457C.37.317.663.132.706,0Z",
    transform: "translate(15.771 16.931)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56475",
    "data-name": "Path 56475",
    d: "M.505,0A6.235,6.235,0,0,0,.544,1.519a6.712,6.712,0,0,1-.045.9,2.76,2.76,0,0,0-.112.725A4.565,4.565,0,0,1,0,1.344,2.735,2.735,0,0,1,.191.43C.255.275.461.134.505,0Z",
    transform: "translate(16.392 18.02)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56476",
    "data-name": "Path 56476",
    d: "M.577.01A2.232,2.232,0,0,1,2.091.987a2.6,2.6,0,0,1,.374.777,2.5,2.5,0,0,1,.088.5,2.232,2.232,0,0,0,0,.445,15.5,15.5,0,0,0-1.17-1.457C1.075.872.581.056,0,.129.052.129.186.02.261.009a1.371,1.371,0,0,1,.316,0Z",
    transform: "translate(16.115 9.084)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56477",
    "data-name": "Path 56477",
    d: "M1.05.2A1.314,1.314,0,0,0,0,.064C.112.026.307.132.4.183A1.87,1.87,0,0,1,.584.313C.574.3.842.547.722.426c.334.332.587.736.886,1.1a13.98,13.98,0,0,0,1.1,1.11,3.392,3.392,0,0,1-.109-.6,3.474,3.474,0,0,0-.292-.7A2.7,2.7,0,0,0,1.05.2ZM.786.49Z",
    transform: "translate(16.152 10.013)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56478",
    "data-name": "Path 56478",
    d: "M.46.011A2.724,2.724,0,0,1,2.183,1.055a3.184,3.184,0,0,1,.487,2.1c0-.076-.2-.3-.244-.372-.106-.166-.211-.333-.319-.5-.21-.325-.434-.641-.654-.96A6.9,6.9,0,0,0,.779.483C.626.337.239-.028,0,.032A1.314,1.314,0,0,1,.46.011Z",
    transform: "translate(16.46 11.214)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56479",
    "data-name": "Path 56479",
    d: "M.882.023A1.817,1.817,0,0,1,2.192,1a2.687,2.687,0,0,1,.161,1.658c0-.209-.316-.636-.419-.826A6.316,6.316,0,0,0,1.352,1,1.517,1.517,0,0,0,0,.207C.066.207.245.066.322.04A1.247,1.247,0,0,1,.882.023Z",
    transform: "translate(17.184 12.82)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56480",
    "data-name": "Path 56480",
    d: "M.915.035C1.836.281,2.027,1.152,1.98,1.985a2.409,2.409,0,0,0-.316-.654A2.419,2.419,0,0,0,1.047.579C.862.422,0-.047,0,.554.012.067.5-.075.915.035Z",
    transform: "translate(17.592 14.026)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56481",
    "data-name": "Path 56481",
    d: "M.855.027C.454-.068.029.089,0,.538.185-.015.8.41,1.054.652a4.236,4.236,0,0,1,.481.577,2.093,2.093,0,0,1,.369.707A1.605,1.605,0,0,0,.855.027ZM.155.32Z",
    transform: "translate(18.099 15.404)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56482",
    "data-name": "Path 56482",
    d: "M1.2.2a1.953,1.953,0,0,1,.956,1.175,2.336,2.336,0,0,1,.078.769,3.258,3.258,0,0,0-.053.643,11.05,11.05,0,0,0-.912-1.741C1.093.8.4-.15,0,.247.279-.155.843.011,1.2.2Z",
    transform: "translate(18.246 16.389)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56483",
    "data-name": "Path 56483",
    d: "M.443.015A.723.723,0,0,0,0,.066c.325-.216,1.169.9,1.312,1.087A9.52,9.52,0,0,1,2.282,3a3.47,3.47,0,0,1,.047-.815,2.093,2.093,0,0,0-.277-1.035A2.374,2.374,0,0,0,.443.015ZM.33.169Z",
    transform: "translate(18.738 17.727)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56484",
    "data-name": "Path 56484",
    d: "M.63.042C.412-.019.116-.047,0,.195.145-.1.886.737.967.825a6.975,6.975,0,0,1,.884,1.17c-.01-.017.071.12.071.119A1.88,1.88,0,0,0,.63.042ZM.178.162Z",
    transform: "translate(19.316 19.123)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56485",
    "data-name": "Path 56485",
    d: "M.223,0C.086-.016.024.061,0,.18c0-.2.318.056.338.075a6.83,6.83,0,0,1,.733.911A6.854,6.854,0,0,1,1.7,2.219c.093.205.177.414.269.62.037.08.259.426.235.5A3.7,3.7,0,0,0,1.853,1.2,2.4,2.4,0,0,0,.223,0ZM.05.124Z",
    transform: "translate(20.116 20.771)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56486",
    "data-name": "Path 56486",
    d: "M0,0A1.98,1.98,0,0,1,1.437,2.693c.05-.148-.12-.537-.173-.681a5.62,5.62,0,0,0-.387-.756C.738,1.031.6.809.45.591.345.437.167.084,0,0Z",
    transform: "translate(20.662 22.331)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56487",
    "data-name": "Path 56487",
    d: "M0,0C.059.225.15.67.179.774A8.4,8.4,0,0,0,.538,1.843c.085.211.366.746.29.973A2.31,2.31,0,0,0,0,0ZM.737,2.395Z",
    transform: "translate(21.033 24.133)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56488",
    "data-name": "Path 56488",
    d: "M0,0A5.475,5.475,0,0,1,.563,1.582a3.151,3.151,0,0,1,.026.781c-.018.179-.216.4-.216.549A9.79,9.79,0,0,0,.15,1.46C.1,1.173.056.883.029.592A3.221,3.221,0,0,0,0,0Z",
    transform: "translate(20.943 25.651)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56489",
    "data-name": "Path 56489",
    d: "M.25,0C.248.007.217.115.229.078l0,.013A7.269,7.269,0,0,0,.017.966a8.767,8.767,0,0,0,.014,1.1,3.407,3.407,0,0,1,.034.754C.624,2.064,1.026.774.25,0ZM.226.087c0-.014,0,.006,0,0Z",
    transform: "translate(20.398 27.461)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56490",
    "data-name": "Path 56490",
    d: "M.478,0A3.051,3.051,0,0,1,.622,1.7a2.924,2.924,0,0,1-.256.765C.309,2.573,0,2.886,0,2.984c.014-.538.028-1.1.095-1.634A4.294,4.294,0,0,1,.282.54C.316.439.509.092.478,0Z",
    transform: "translate(19.586 28.747)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56491",
    "data-name": "Path 56491",
    d: "M.323,0A1.922,1.922,0,0,1,.614,1.323a1.928,1.928,0,0,1-.209.626,4.772,4.772,0,0,0-.363.556C.02,2.185.009,1.863.007,1.543.007,1.6,0,1.208,0,1.261A3.412,3.412,0,0,1,.09.625,4.349,4.349,0,0,0,.323,0Z",
    transform: "translate(18.871 30.457)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56492",
    "data-name": "Path 56492",
    d: "M.512,0A2.331,2.331,0,0,1,.818,1.6a2.153,2.153,0,0,1-.266.691,1.165,1.165,0,0,1-.227.276C.275,2.614.017,2.751,0,2.8A5.279,5.279,0,0,0,.157,1.334,3.118,3.118,0,0,1,.309.474,3.376,3.376,0,0,0,.512,0Z",
    transform: "translate(17.837 31.918)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56493",
    "data-name": "Path 56493",
    d: "M.259,0c.654.588.332,1.85-.2,2.4.058-.058-.006-.456-.013-.537A6.426,6.426,0,0,1,0,1.181C0,1.39.019.938.017.956A2.592,2.592,0,0,1,.1.541C.119.477.3.04.259,0Z",
    transform: "translate(17.017 33.706)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56494",
    "data-name": "Path 56494",
    d: "M.381,0C.835.538.788,1.711,0,1.919a1.54,1.54,0,0,0,.109-.248c.008-.056.026-.525.026-.368A3.032,3.032,0,0,1,.206.558,2.717,2.717,0,0,0,.381,0Z",
    transform: "translate(15.802 35.267)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56495",
    "data-name": "Path 56495",
    d: "M.332.453A.67.67,0,0,1,.219.809C.175.869.025.933,0,.982A6.472,6.472,0,0,0,.094,0,.451.451,0,0,1,.332.453Z",
    transform: "translate(14.914 36.25)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56496",
    "data-name": "Path 56496",
    d: "M0,0C.711.492,1.459.924,2.173,1.411a9.377,9.377,0,0,0,.966.61c.243.126.756.392,1.036.3a3.358,3.358,0,0,1-2.788-.06A2.571,2.571,0,0,1,.41,1.266a2.921,2.921,0,0,1-.3-.74A2.514,2.514,0,0,0,0,0Z",
    transform: "translate(9.593 26.726)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56497",
    "data-name": "Path 56497",
    d: "M.009,0C.677.913,1.291,1.873,2.028,2.728A14.5,14.5,0,0,0,3.4,3.953a3.863,3.863,0,0,0,.785.54,1.381,1.381,0,0,0,.772.185,5.013,5.013,0,0,1-2,.036A2.852,2.852,0,0,1,.877,3.9,3.257,3.257,0,0,1,.025,2.02C-.011,1.634,0,1.245,0,.858,0,.723.094.085.009,0Z",
    transform: "translate(8.706 23.031)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56498",
    "data-name": "Path 56498",
    d: "M.079,0C.474.7.851,1.416,1.3,2.081A11,11,0,0,0,2.811,3.742c.506.5,1.021,1,1.561,1.458a4.85,4.85,0,0,0,.92.609,2.278,2.278,0,0,0,.853.339,23.994,23.994,0,0,1-2.535-.38,4.917,4.917,0,0,1-2.277-.82C-.281,3.807-.015,1.914.069.193A1.117,1.117,0,0,1,.079,0Z",
    transform: "translate(8.562 20.386)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56499",
    "data-name": "Path 56499",
    d: "M.43,0A11.264,11.264,0,0,0,0,2.4,3.483,3.483,0,0,0,1,4.883a5.668,5.668,0,0,0,2.28,1.333,16.637,16.637,0,0,0,2.822.84,3.763,3.763,0,0,1-.872-.5,5.331,5.331,0,0,1-.865-.692c-.586-.56-1.105-1.19-1.635-1.8A12.229,12.229,0,0,1,1.374,2.277,11.087,11.087,0,0,1,.43,0ZM5.068,6.459Z",
    transform: "translate(8.332 17.511)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56500",
    "data-name": "Path 56500",
    d: "M0,0C.627.815,1.1,1.723,1.734,2.53c.3.382.575.784.876,1.166.149.19.3.377.459.562q.14.166.283.33c.021.025.339.384.109.126a11.253,11.253,0,0,0,1.86,1.973c-.27-.18-.622-.287-.905-.47A5.721,5.721,0,0,0,3.4,5.653,6.567,6.567,0,0,1,1.2,4.611,3.708,3.708,0,0,1,.065,2.471,5.685,5.685,0,0,1,.034,1.209C.043.962.043.715.029.469A1.741,1.741,0,0,0,0,0Z",
    transform: "translate(8.612 15.891)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56501",
    "data-name": "Path 56501",
    d: "M0,0C.379.256.754.533,1.155.756s.87.352,1.283.579A8.4,8.4,0,0,1,4.666,3.626,5.62,5.62,0,0,0,4.058,3.2a4.993,4.993,0,0,0-.738-.474c-.557-.279-1.192-.323-1.765-.568A2.22,2.22,0,0,1,.442,1.224,3.587,3.587,0,0,1,.163.57C.131.472.074.05,0,0Z",
    transform: "translate(8.954 17.058)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56502",
    "data-name": "Path 56502",
    d: "M1.765,0C1.441.459,1.2.994.894,1.467A8.4,8.4,0,0,0,.355,2.4c-.081.167-.154.339-.22.513a1.733,1.733,0,0,1-.135.4C1.222,2.622,2.4,1.536,1.765,0ZM.483,2.151c.031-.055-.041.075,0,0Zm.008-.014.027-.05Z",
    transform: "translate(6.601 32.512)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56503",
    "data-name": "Path 56503",
    d: "M1.72,0a3.718,3.718,0,0,1-.026,2.676A4.263,4.263,0,0,1,.971,3.795a3.921,3.921,0,0,1-.443.421c-.07.057-.514.26-.528.3A19.786,19.786,0,0,0,.834,2.242C1,1.82,1.18,1.408,1.33.979c.064-.184.129-.368.2-.548C1.559.367,1.739.057,1.72,0Z",
    transform: "translate(5.753 32.195)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56504",
    "data-name": "Path 56504",
    d: "M1.43,0A3.13,3.13,0,0,1,1.7,2.74,4.431,4.431,0,0,1,0,5.177c.167-.112.22-.831.259-1.022C.352,3.7.446,3.247.567,2.8S.841,1.934,1,1.508q.1-.258.176-.522.04-.132.075-.265c-.01.036.1-.383.05-.186C1.318.467,1.47.06,1.43,0Z",
    transform: "translate(5.209 31.512)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56505",
    "data-name": "Path 56505",
    d: "M1.7,0a6.362,6.362,0,0,1,.171,3.415,5.611,5.611,0,0,1-.778,1.529c-.163.232-.338.456-.52.673C.438,5.77.046,6.069,0,6.253A32.793,32.793,0,0,1,.914,2.821c.169-.517.344-1.026.484-1.552A5.682,5.682,0,0,0,1.7,0Z",
    transform: "translate(4.291 31.005)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56506",
    "data-name": "Path 56506",
    d: "M1.658.013C1.7.043,1,1.571.929,1.728c-.142.3-.3.6-.469.886-.066.114-.135.227-.211.335C.216,3,0,3.211,0,3.256.033,1.95.226.655,1.538.047c-.117-.045.08-.061.119-.034Z",
    transform: "translate(4.532 35.489)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56507",
    "data-name": "Path 56507",
    d: "M4.386.37a1.8,1.8,0,0,1-.12,1.976c-.082.155-.171.306-.249.462-.069.138-.069.282-.126.426a1.085,1.085,0,0,1-.255.382,1.648,1.648,0,0,0-.285.62c-.265.681-.749,1.407-1.59,1.219-.126-.028-.216.093-.342.133a.753.753,0,0,1-.431,0,1.11,1.11,0,0,1-.635-.646A2.394,2.394,0,0,1,.225,2.7c.144-.277.213-.572.342-.858a1.541,1.541,0,0,1,.157-.309c.129-.167.3-.085.414-.226A2.977,2.977,0,0,1,1.7.663c.246-.169.53-.522.839-.571a.487.487,0,0,1,.423.141A.915.915,0,0,1,3.457.009,1.04,1.04,0,0,1,4.386.37Z",
    transform: "translate(2.419 34.387)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56508",
    "data-name": "Path 56508",
    d: "M5.852,0a8.587,8.587,0,0,0-1.08.474c-.483.211-.976.393-1.452.621-.858.41-1.7.979-2.57,1.3-.134.05-.622.284-.75.22a3.366,3.366,0,0,0,3.24-.435A10.665,10.665,0,0,0,4.42,1.208,9.188,9.188,0,0,1,5.694.1L5.7.1C5.712.089,5.837.01,5.852,0ZM.8,2.377ZM5.7.1c.005,0,0,0,0,0Z",
    transform: "translate(12.044 40.683)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56509",
    "data-name": "Path 56509",
    d: "M4.315,0C3.7.5,3.362,1.227,2.658,1.654c-.667.4-1.927.833-2.658.372.092.092.956-.356,1.062-.406.42-.2.838-.4,1.274-.557q-.189.071.045-.018c.144-.056.287-.114.429-.177a5.461,5.461,0,0,0,.68-.354C3.671.4,3.84.275,4.014.149c.079-.057.24-.088.3-.149Z",
    transform: "translate(10.172 42.926)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56510",
    "data-name": "Path 56510",
    d: "M4.5,0a6.145,6.145,0,0,0-.8.543,5.9,5.9,0,0,1-1.143.616A16.391,16.391,0,0,0,0,2.3a.924.924,0,0,1,.27.053,3.9,3.9,0,0,0,2.5-.361C3.6,1.536,3.908.685,4.5,0ZM3.789.479ZM3.763.5Z",
    transform: "translate(9.199 44.04)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56511",
    "data-name": "Path 56511",
    d: "M4.449,0A4.4,4.4,0,0,1,2.826,2.229,2.62,2.62,0,0,1,1.5,2.541a4.311,4.311,0,0,1-.763-.089A3.766,3.766,0,0,0,0,2.276a5.2,5.2,0,0,1,1.275-.464c.422-.139.84-.286,1.246-.465A4.912,4.912,0,0,0,3.665.673c.152-.125.3-.256.446-.386C4.175.23,4.424.074,4.449,0Z",
    transform: "translate(7.974 45.581)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56512",
    "data-name": "Path 56512",
    d: "M4.423,0A8.8,8.8,0,0,1,2.165,1.136c-.144.054-.287.109-.431.162-.159.06-1.656.554-1.735.4.119.272.814.376,1.065.421a2.678,2.678,0,0,0,1.417-.109A3.61,3.61,0,0,0,4.423,0Zm-.34.253Z",
    transform: "translate(6.904 47.214)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56513",
    "data-name": "Path 56513",
    d: "M4.54,0c-.409.259-.752.628-1.15.91A10.029,10.029,0,0,1,1.372,1.932a5.2,5.2,0,0,1-1.254.309c.005,0-.12.011-.118.012a2.617,2.617,0,0,0,2.763.089A4.975,4.975,0,0,0,4.54,0Zm-.1.193ZM1.453,1.9ZM.13,2.24Z",
    transform: "translate(6.025 48.402)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56514",
    "data-name": "Path 56514",
    d: "M4.81,0C4.055.547,3.427,1.346,2.444,1.487A2.011,2.011,0,0,1,.976,1.113,3.5,3.5,0,0,1,.4.593C.315.494.113.124,0,.086c.407.077.808.2,1.214.282a6.787,6.787,0,0,0,1.347.1A4.792,4.792,0,0,0,3.746.363,4.761,4.761,0,0,0,4.4.142,1.9,1.9,0,0,0,4.81,0Z",
    transform: "translate(3.836 50.834)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56515",
    "data-name": "Path 56515",
    d: "M0,0A6.727,6.727,0,0,0,1.3,1.116a2.478,2.478,0,0,0,.58.361,6.13,6.13,0,0,1,.787.225c.006.017,0,.023-.024.018A3.606,3.606,0,0,1,.78,1.534a1.43,1.43,0,0,1-.647-.7A2.009,2.009,0,0,1,.005.354C0,.314.014.014,0,0Z",
    transform: "translate(2.286 50.603)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56516",
    "data-name": "Path 56516",
    d: "M6.84,0A11.254,11.254,0,0,0,4.481,1.787a9.626,9.626,0,0,0-1.7,2.79c-.452,1.032-.817,2.1-1.307,3.117C1.221,8.218.96,8.738.707,9.263A6.217,6.217,0,0,1,0,10.536a3.265,3.265,0,0,0,.444-.6C1.5,8.25,2.733,6.626,3.723,4.868c.5-.9.912-1.838,1.432-2.726A14.313,14.313,0,0,1,6.84,0ZM.21,10.259ZM.4,10.014Z",
    transform: "translate(3.619 3.156)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56517",
    "data-name": "Path 56517",
    d: "M2.391,0C1.482-.036.028.44,0,1.557c0-.286.4-.564.608-.7A2.533,2.533,0,0,1,1.589.5,11.089,11.089,0,0,1,3.938.387,2.986,2.986,0,0,1,3.273.143,3.459,3.459,0,0,0,2.391,0Zm-1.1.557Z",
    transform: "translate(7.579 4.321)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56518",
    "data-name": "Path 56518",
    d: "M1.584,0A1.777,1.777,0,0,1,3.006.8C2.932.686,2.52.584,2.391.541A4.6,4.6,0,0,0,1.5.457a5.542,5.542,0,0,0-.752,0C.607.474.091.5,0,.632A1.88,1.88,0,0,1,1.584,0Z",
    transform: "translate(8.874 3.494)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56519",
    "data-name": "Path 56519",
    d: "M1.522.029A1.5,1.5,0,0,1,2.914,1.346,1.624,1.624,0,0,0,2.5.894,1.941,1.941,0,0,0,1.74.579,4.149,4.149,0,0,0,0,.4,1.849,1.849,0,0,1,.2.246,1.427,1.427,0,0,1,.68.045,2.425,2.425,0,0,1,1.522.029Z",
    transform: "translate(10.103 2.59)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56520",
    "data-name": "Path 56520",
    d: "M1.73.2A1.714,1.714,0,0,0,0,.268C.1.216.484.348.6.377c.268.066.534.138.8.224.313.1.93.321,1.05.68A1.338,1.338,0,0,0,1.73.2Zm.622.98Z",
    transform: "translate(11.51 1.843)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56521",
    "data-name": "Path 56521",
    d: "M.854.041A2.912,2.912,0,0,1,2.047.547a1.709,1.709,0,0,1,.435.487,2.3,2.3,0,0,1,.154.538A2.724,2.724,0,0,0,1.422.623C1.221.524.209-.087,0,.123A1.184,1.184,0,0,1,.854.041Z",
    transform: "translate(12.51 1.31)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56522",
    "data-name": "Path 56522",
    d: "M.585.022A.8.8,0,0,0,0,.1C.438-.043,1.059.668,1.346.918a7.147,7.147,0,0,1,.707.651c.12.137.447.49.447.675A2.287,2.287,0,0,0,.585.022ZM1.935,1.44Z",
    transform: "translate(13.792 0.962)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56523",
    "data-name": "Path 56523",
    d: "M.307,0A2.165,2.165,0,0,1,1.754,1.129a3.764,3.764,0,0,1,.385,2.059c0,.011-.146-.282-.143-.276q-.138-.278-.26-.563c-.144-.338-.3-.667-.468-.994S.506-.115,0,.053A.748.748,0,0,1,.307,0Z",
    transform: "translate(15.679 1.163)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56524",
    "data-name": "Path 56524",
    d: "M.26.028c1.2.413,1.284,2.088,1.077,3.105.038-.114-.208-.585-.25-.716C.98,2.08.863,1.742.768,1.4.715,1.215.33-.1,0,.007A.646.646,0,0,1,.26.028Z",
    transform: "translate(17.576 1.96)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56525",
    "data-name": "Path 56525",
    d: "M0,0A2.147,2.147,0,0,1,.531,3.051c.065-.1-.048-.583-.053-.712a6.266,6.266,0,0,0-.087-.886,7.877,7.877,0,0,0-.183-.8A2.093,2.093,0,0,0,0,0Z",
    transform: "translate(19.312 2.376)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56526",
    "data-name": "Path 56526",
    d: "M0,0C.155.865.082,1.762.17,2.637c.022.2.056.463.088.686a4.5,4.5,0,0,1,.259-.81A3.379,3.379,0,0,0,.639,1.56,2.348,2.348,0,0,0,0,0ZM.169,2.629Z",
    transform: "translate(20.672 3.689)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56527",
    "data-name": "Path 56527",
    d: "M.057,0A3.21,3.21,0,0,1,.042,3.251a2.682,2.682,0,0,0-.029-.7c0-.276,0-.551-.009-.828-.012-.314,0-.628.013-.942C.022.636.131.109.057,0Z",
    transform: "translate(21.876 5.095)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56528",
    "data-name": "Path 56528",
    d: "M.316,0A3.492,3.492,0,0,1,0,3.062,4.975,4.975,0,0,0,.03,2,10.2,10.2,0,0,1,.136.942q-.02.115.01-.071C.164.754.186.637.207.52.223.428.352.072.316,0Z",
    transform: "translate(22.664 6.534)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56529",
    "data-name": "Path 56529",
    d: "M.3,0A3.18,3.18,0,0,1,0,2.626a2.469,2.469,0,0,0,0-.59A7.342,7.342,0,0,1,.06,1.171,9.4,9.4,0,0,0,.3,0Z",
    transform: "translate(23.484 8.059)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56530",
    "data-name": "Path 56530",
    d: "M.5,0A3.208,3.208,0,0,1,0,2.368a1.8,1.8,0,0,0,.019-.46C.034,1.7.058,1.5.092,1.3A5.461,5.461,0,0,1,.278.568,2.576,2.576,0,0,0,.5,0Z",
    transform: "translate(24.083 9.578)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56531",
    "data-name": "Path 56531",
    d: "M.445,0A2.917,2.917,0,0,1,0,2.544a1.806,1.806,0,0,0,.037-.516,7.971,7.971,0,0,1,.1-.83c.029-.176.1-.457.152-.67A2.8,2.8,0,0,0,.445,0Z",
    transform: "translate(24.645 11.207)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56532",
    "data-name": "Path 56532",
    d: "M.56,0A2.424,2.424,0,0,1,.536,1.09a1.765,1.765,0,0,1-.215.467c-.048.075-.322.336-.322.4.039-.306.08-.613.135-.917-.032.2.052-.221.048-.2A2.853,2.853,0,0,1,.314.467C.362.357.56.108.56,0Z",
    transform: "translate(25.127 13.317)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56533",
    "data-name": "Path 56533",
    d: "M.7,0A2.242,2.242,0,0,1,0,2.428a2.047,2.047,0,0,0,.112-.536c.051-.228.115-.453.168-.68A4.385,4.385,0,0,1,.493.553C.532.459.727.087.7,0Z",
    transform: "translate(25.383 14.878)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56534",
    "data-name": "Path 56534",
    d: "M.667,0A3.68,3.68,0,0,1,.52,1.134c-.114.375-.4.679-.52,1.033.024-.245.056-.49.1-.733A5.159,5.159,0,0,1,.3.719C.373.542.667.172.667,0Z",
    transform: "translate(26.103 16.771)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56535",
    "data-name": "Path 56535",
    d: "M.961,0A3.1,3.1,0,0,1,0,2.356c.073-.073.092-.434.121-.543a5.726,5.726,0,0,1,.216-.661A5.108,5.108,0,0,1,.665.5c.064-.111.3-.38.3-.5Z",
    transform: "translate(26.043 18.791)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56536",
    "data-name": "Path 56536",
    d: "M.974,0A2.293,2.293,0,0,1,.729,1.177a2.868,2.868,0,0,1-.364.562c-.084.1-.325.278-.364.4A11.062,11.062,0,0,1,.539.88C.658.655.974.258.974,0Z",
    transform: "translate(26.111 20.991)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56537",
    "data-name": "Path 56537",
    d: "M.934,0A2.78,2.78,0,0,1,.669,1.084a2.51,2.51,0,0,1-.29.469c-.082.107-.34.288-.378.4A9.9,9.9,0,0,1,.424.913C.513.736.613.564.711.391.756.311.934.086.934,0Z",
    transform: "translate(26.096 23.105)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56538",
    "data-name": "Path 56538",
    d: "M1.074,0A2.986,2.986,0,0,1,0,2a1.693,1.693,0,0,0,.152-.4A6.5,6.5,0,0,1,.457.962c.115-.21.256-.4.385-.6C.885.291,1.074.071,1.074,0Z",
    transform: "translate(25.711 25.343)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56539",
    "data-name": "Path 56539",
    d: "M.853,0A5.756,5.756,0,0,1,.848,1.976a4.434,4.434,0,0,1-.327.978C.393,3.236.093,3.51,0,3.789c.1-.7.215-1.4.38-2.087.081-.334.163-.668.255-1A3.353,3.353,0,0,0,.853,0Z",
    transform: "translate(6.309 17.884)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56540",
    "data-name": "Path 56540",
    d: "M.7,0A2.717,2.717,0,0,1,0,2.7c.064-.064.076-.428.1-.528.067-.278.127-.558.193-.836S.45.8.533.533C.564.433.733.091.7,0Z",
    transform: "translate(6.699 20.271)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56541",
    "data-name": "Path 56541",
    d: "M.74,0A2.562,2.562,0,0,1,.663,1.422a2.153,2.153,0,0,1-.282.532C.3,2.061.034,2.23,0,2.335c.119-.423.211-.856.341-1.274C.411.835.495.614.581.395.605.333.758.056.74,0Z",
    transform: "translate(6.898 22.235)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56542",
    "data-name": "Path 56542",
    d: "M.707,0A1.7,1.7,0,0,1,0,1.864c.109-.055.175-.82.218-.958A2.737,2.737,0,0,1,.489.319,2.83,2.83,0,0,0,.707,0Z",
    transform: "translate(7.357 24.397)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56543",
    "data-name": "Path 56543",
    d: "M.508,0A2.641,2.641,0,0,1,.5,1.013a2.592,2.592,0,0,1-.15.486A4.013,4.013,0,0,0,.1,1.946,2.346,2.346,0,0,1,.066.738,1.785,1.785,0,0,1,.279.294C.311.245.508.045.508,0Z",
    transform: "translate(18.739 21.826)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56544",
    "data-name": "Path 56544",
    d: "M.661,0A4.241,4.241,0,0,1,.1,2.5c.023-.023-.09-.529-.093-.6A2.511,2.511,0,0,1,.1,1.025,2.782,2.782,0,0,1,.369.441C.422.351.661.093.661,0Z",
    transform: "translate(19.11 22.944)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56545",
    "data-name": "Path 56545",
    d: "M1.34,0A4.311,4.311,0,0,1,0,2.812c.084-.084.082-.577.111-.709a3.607,3.607,0,0,1,.332-.935A4.268,4.268,0,0,1,.89.5C.959.414,1.34.089,1.34,0Z",
    transform: "translate(18.816 24.809)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56546",
    "data-name": "Path 56546",
    d: "M1.382,0A4.16,4.16,0,0,0,.617.673a3.32,3.32,0,0,0-.386.563c-.045.082-.161.461-.231.5A2.95,2.95,0,0,0,1.382,0ZM.617.673Z",
    transform: "translate(17.649 28.148)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56547",
    "data-name": "Path 56547",
    d: "M3.331,0A4.14,4.14,0,0,0,0,2.157c.1-.146.6-.293.768-.389.276-.159.546-.332.812-.506C2.18.871,2.768.441,3.331,0ZM1.783,1.123Z",
    transform: "translate(10.966 38.382)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56548",
    "data-name": "Path 56548",
    d: "M2.569,0A5.181,5.181,0,0,1,0,2.78c.124-.041.383-.67.458-.8a6.045,6.045,0,0,1,.608-.886A4.072,4.072,0,0,1,1.886.349,3.136,3.136,0,0,1,2.329.1a2.39,2.39,0,0,1,.24-.1Z",
    transform: "translate(9.149 38.724)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56549",
    "data-name": "Path 56549",
    d: "M2.467,0A3.385,3.385,0,0,0,1.013,1.248a6.947,6.947,0,0,0-.549.989c-.086.181-.169.363-.247.548A2.276,2.276,0,0,1,0,3.344C1.263,2.565,1.789,1.246,2.467,0Zm-.5.974Z",
    transform: "translate(7.415 39.092)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56550",
    "data-name": "Path 56550",
    d: "M1.624,0A3.813,3.813,0,0,1,0,3.01a2.633,2.633,0,0,0,.234-.76,6.494,6.494,0,0,1,.36-.956A3.845,3.845,0,0,1,1.108.508C1.176.427,1.624.077,1.624,0Z",
    transform: "translate(6.264 39.571)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56551",
    "data-name": "Path 56551",
    d: "M1.42,0C1.664.989,1.23,2.566,0,2.6c.047,0,.219-.257.245-.3a5.562,5.562,0,0,0,.406-.889A7.465,7.465,0,0,1,1.024.635c.048-.087.418-.567.4-.635Z",
    transform: "translate(4.61 40.599)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56552",
    "data-name": "Path 56552",
    d: "M1.757,0a4.264,4.264,0,0,1-.77.794C.805.935.62,1.071.448,1.222c-.072.063-.376.454-.448.454C.94,1.651,2.037,1.119,1.757,0ZM1.487.349Z",
    transform: "translate(2.745 41.62)",
    fill: "#909090"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, 954.083, 534.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_003---Clean-Hand",
    "data-name": "003---Clean-Hand",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.715,29.737a8.273,8.273,0,0,1,3.218,1.09,4.24,4.24,0,0,1,2.019,2.289,13.448,13.448,0,0,0,2.526,3.731,14.324,14.324,0,0,0,2.417,2.137c2.317,1.8,2.353,5.995,2.353,6.036a.763.763,0,1,0,1.526,0c0-.2-.034-4.978-2.98-7.268a13.048,13.048,0,0,1-2.2-1.94,11.938,11.938,0,0,1-2.269-3.358A5.706,5.706,0,0,0,6.7,29.51a9.754,9.754,0,0,0-3.8-1.288,1.526,1.526,0,0,1,.086-3.042A13.605,13.605,0,0,1,11.29,27.5a1.547,1.547,0,0,0,1.408.2,1.492,1.492,0,0,0,.947-1.011l.076-.268a9.661,9.661,0,0,0,.4-4.836L11.35,6.408A1.529,1.529,0,0,1,13.7,4.835a1.552,1.552,0,0,1,.659,1l3.968,16.474a.762.762,0,0,0,1.5-.181V3.135a1.585,1.585,0,0,1,1.221-1.578,1.526,1.526,0,0,1,1.831,1.494V22.127a.763.763,0,0,0,1.506.174L28.25,5.8a1.5,1.5,0,0,1,.649-.964,1.523,1.523,0,0,1,2.344,1.552L27.809,21.96a.763.763,0,0,0,1.412.534l5.245-9.413a1.526,1.526,0,0,1,2.3-.568,1.6,1.6,0,0,1,.426,1.958l-4.539,9.952c-.657,1.45-.652,2.236-.63,5.994.006.868.012,1.905.012,3.157,0,2.235,0,3.586-1.4,5.681-1.055,1.583-.91,5.374-.89,5.8a.763.763,0,0,0,.762.729h.037a.763.763,0,0,0,.726-.8c-.066-1.419.047-4,.636-4.884,1.654-2.482,1.654-4.177,1.654-6.527,0-1.255-.006-2.295-.012-3.166-.022-3.647-.025-4.207.493-5.354l4.539-9.947a3.111,3.111,0,0,0-.916-3.829,3.066,3.066,0,0,0-2.578-.5,3,3,0,0,0-1.976,1.614l-2.688,4.823L32.736,6.7a3.052,3.052,0,0,0-5.978-1.225L24.4,15.528V3.051A3.052,3.052,0,0,0,20.76.058,3.09,3.09,0,0,0,18.3,3.135V15.7L15.843,5.5A3.055,3.055,0,0,0,9.85,6.692L12.62,21.86A8.25,8.25,0,0,1,12.256,26l-.082.254a15.04,15.04,0,0,0-9.288-2.6,3.052,3.052,0,0,0-.169,6.082Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4.651,4.921a.764.764,0,0,0,1.367-.683A8.4,8.4,0,0,0,.938.02.764.764,0,0,0,.565,1.5,6.971,6.971,0,0,1,4.651,4.921Z",
    transform: "translate(16.02 28.232)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M1.527.764A.764.764,0,0,0,0,.764v.764a.764.764,0,1,0,1.527,0Z",
    transform: "translate(21.352 36.624)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M.764,1.527h.764A.764.764,0,1,0,1.527,0H.764a.764.764,0,0,0,0,1.527Z",
    transform: "translate(22.878 38.91)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M.764,2.291a.764.764,0,0,0,.764-.764V.764A.764.764,0,1,0,0,.764v.764A.764.764,0,0,0,.764,2.291Z",
    transform: "translate(21.352 40.437)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M.764,1.527h.764A.764.764,0,1,0,1.527,0H.764a.764.764,0,0,0,0,1.527Z",
    transform: "translate(19.063 38.91)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M.764,2.291a.764.764,0,0,0,.764-.764V.764A.764.764,0,1,0,0,.764v.764A.764.764,0,0,0,.764,2.291Z",
    transform: "translate(5.332 8.392)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M.764,1.527h.764A.764.764,0,1,0,1.527,0H.764a.764.764,0,1,0,0,1.527Z",
    transform: "translate(6.854 10.681)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M.764,0A.764.764,0,0,0,0,.764v.764a.764.764,0,1,0,1.527,0V.764A.764.764,0,0,0,.764,0Z",
    transform: "translate(5.332 12.207)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M.764,1.527h.764A.764.764,0,1,0,1.527,0H.764a.764.764,0,1,0,0,1.527Z",
    transform: "translate(3.041 10.681)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M1.527.764A.764.764,0,1,0,0,.764v.764a.764.764,0,0,0,1.527,0Z",
    transform: "translate(25.93 25.179)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M.764,1.527h.764A.764.764,0,0,0,1.527,0H.764a.764.764,0,0,0,0,1.527Z",
    transform: "translate(27.456 27.468)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M.764,2.291a.764.764,0,0,0,.764-.764V.764A.764.764,0,1,0,0,.764v.764A.764.764,0,0,0,.764,2.291Z",
    transform: "translate(25.93 28.994)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M2.291.764A.764.764,0,0,0,1.527,0H.764a.764.764,0,0,0,0,1.527h.764A.764.764,0,0,0,2.291.764Z",
    transform: "translate(23.641 27.468)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M.764,0A.764.764,0,0,0,0,.764v.764a.764.764,0,1,0,1.527,0V.764A.764.764,0,0,0,.764,0Z",
    transform: "translate(37.374 28.994)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M.764,1.527h.764A.764.764,0,1,0,1.527,0H.764a.764.764,0,1,0,0,1.527Z",
    transform: "translate(38.902 31.283)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M.764,2.291a.764.764,0,0,0,.764-.764V.764A.764.764,0,0,0,0,.764v.764A.764.764,0,0,0,.764,2.291Z",
    transform: "translate(37.374 32.809)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    "data-name": "Shape",
    d: "M1.527,0H.764a.764.764,0,1,0,0,1.527h.764A.764.764,0,1,0,1.527,0Z",
    transform: "translate(35.083 31.283)",
    fill: "#909090"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 708.649, 440.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29807",
    "data-name": "Group 29807",
    transform: "translate(18.471 17.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29806-2",
    "data-name": "Group 29806",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59416",
    "data-name": "Path 59416",
    d: "M1.7.291a.993.993,0,1,0,0,1.4A.992.992,0,0,0,1.7.291Z",
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29809",
    "data-name": "Group 29809",
    transform: "translate(22.443 19.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29808",
    "data-name": "Group 29808",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59417",
    "data-name": "Path 59417",
    d: "M2.979,0A2.979,2.979,0,1,0,5.958,2.979,2.983,2.983,0,0,0,2.979,0Zm0,3.972a.993.993,0,1,1,.993-.993A.994.994,0,0,1,2.979,3.972Z",
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29811",
    "data-name": "Group 29811",
    transform: "translate(17.478 14.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29810",
    "data-name": "Group 29810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59418",
    "data-name": "Path 59418",
    d: "M7.944,0a7.878,7.878,0,0,0-3.19.667.993.993,0,1,0,.8,1.818,5.9,5.9,0,0,1,2.391-.5A5.958,5.958,0,1,1,1.986,7.944c0-.034,0-.067,0-.1A.993.993,0,0,0,0,7.8c0,.049,0,.1,0,.147A7.944,7.944,0,1,0,7.944,0Z",
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29813",
    "data-name": "Group 29813",
    transform: "translate(24.429 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29812",
    "data-name": "Group 29812",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59419",
    "data-name": "Path 59419",
    d: "M.993,0A.993.993,0,0,0,0,.993V6.951a.993.993,0,0,0,1.986,0V.993A.993.993,0,0,0,.993,0Z",
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29815",
    "data-name": "Group 29815",
    transform: "translate(8.42 2.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29814",
    "data-name": "Group 29814",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59420",
    "data-name": "Path 59420",
    d: "M5.908,4.5,1.7.291a.993.993,0,0,0-1.4,1.4L4.5,5.908a.993.993,0,0,0,1.4-1.4Z",
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29817",
    "data-name": "Group 29817",
    transform: "translate(36.226 2.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29816",
    "data-name": "Group 29816",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59421",
    "data-name": "Path 59421",
    d: "M5.908.291a.993.993,0,0,0-1.4,0L.291,4.5a.993.993,0,0,0,1.4,1.4L5.908,1.7A.993.993,0,0,0,5.908.291Z",
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29819",
    "data-name": "Group 29819",
    transform: "translate(0 9.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29818",
    "data-name": "Group 29818",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59422",
    "data-name": "Path 59422",
    d: "M50.6,13.08C44.287,5.938,34.92,0,25.422,0S6.556,5.939.249,13.08a.993.993,0,1,0,1.489,1.315c.212-.24.428-.478.648-.716A27.959,27.959,0,0,0,25.422,25.819,27.959,27.959,0,0,0,48.459,13.679c.22.237.436.476.648.716A.993.993,0,1,0,50.6,13.08ZM25.422,23.833A25.894,25.894,0,0,1,3.8,12.217C7.343,8.75,15.518,1.986,25.422,1.986S43.5,8.75,47.04,12.216A25.894,25.894,0,0,1,25.422,23.833Z",
    fill: "#909090"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningStyle);
export default __webpack_public_path__ + "static/media/learning-style.93d8b256b3a8f092de8f7ee0867f2f74.svg";
export { ForwardRef as ReactComponent };